import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initGA, logPageView, initStatsig } from './utils/analytics'

// Initialize GA4
initGA();
logPageView();

// Initialize Statsig (replace with real user info as needed)
initStatsig('anonymous-user');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
